<template>
  <div v-if="isShowOpenUp">
    <!-- 遮罩 -->
    <div class="zhezhao"></div>
    <!-- 是否开通按钮 -->
    <div class="open-up-box">
      <div>
        <img @click="closeModal" class="tc-on shut" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div class="box-title" style="background:#3a3959;">
        <p style="position:relative;padding:18px 25px;">
          <img style="width:150px;" src="/static/img/header-logo.png" alt />
        </p>
      </div>
      <div>
        <img style="display:block;width:100%;height:100%;" src="/static/img/colordiv.png" alt />
      </div>
      <!-- 当前企业 -->
      <div class="box-content">
        <div v-if="unauthorized" class="reg-mess">
          <ul class="cloud-kind">
            <li :class="appId=='trade-app'?'kind-active':''" @click="appId='trade-app'">
              <img src="/static/img/trade.svg" alt />
              <span>贸易云</span>
            </li>
            <li :class="appId=='make-app'?'kind-active':''" @click="appId='make-app'">
              <img src="/static/img/make.svg" alt />
              <span>制造云</span>
            </li>
            <div style="clear:both;"></div>
          </ul>
          <div class="nowcompany">
            <p>
              当前企业：
              <span style="color:red">{{unauthorized.name}}</span>
            </p>
          </div>
          <!-- 是否开通 -->
          <div class="is-openup">
            <p class="notice">
              <span style="color:red;">*</span>开通即是表示同意
              <a href="https://saas-help.usoftchina.com/doc/base/service_protocol" target="_blank">《华商云服平台服务条款》</a>
            </p>
            <p class="aa">
              <div style="margin-right:34px;font-size:14px;">您尚未开通</div>
              <label for="company" v-if="inviteCode">专属顾问</label>
              <input type="text" id="inviteCode" readonly="readonly" v-model="partner.name" v-if="inviteCode" />
              <a class="open-up-btn" @click="applyApp()">
                <span>立即开通</span>
              </a>
            </p>
          </div>
        </div>
        <div class="has-been-openup" v-if="session && session.account.companies.length">
          <span>您有以下关联已开通企业：</span>
          <ul>
            <li v-for="(item,i) in session.account.companies" :key="i">
              <a href="javascript:;" @click="redirectApp(item)">{{item.name}}</a>
            </li>
          </ul>
        </div>
        <!-- 注册新企业 -->
        <div class="register">
          <span @click="checkRegister">注册新企业</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Session from "@/utils/session";
export default {
  data() {
    return {
      appId: 'trade-app',
      inviteCode: null,
      partner: { name: null }
    }
  },
  computed: {
    isShowOpenUp() {
      return this.$store.state.isOpenUp;
    },
    unauthorized() {
      return this.$store.state.unauthorized;
    },
    session() {
      return Session.get();
    }
  },
  watch: {
    isShowOpenUp(is) {
      if (is) {
        // 从邀请链接过来
        let inviteCode = this.$route.query.code;
        if (inviteCode) {
          this.getPartnerInfo(inviteCode);
        }
      }
    }
  },
  methods: {
    closeModal: function() {
      this.$store.commit("setOpenUphide");
    },
    checkRegister: function() {
      this.$store.commit("setOpenUphide");
      this.$store.commit("clickloginfalse");
      this.$store.commit("clickregistertrue");
    },
    /**
     * 开通应用
     */
    applyApp() {
      let company = {
        name: this.unauthorized.name,
        uu: this.unauthorized.uu,
        address: this.unauthorized.address,
        businessCode: this.unauthorized.businessCode,
        areaCategory: this.unauthorized.areaCategory
      };
      let account = {
        realname: this.session.account.realname,
        uu: this.session.account.uu,
        email: this.session.account.email,
        mobile: this.session.account.mobile
      };
      this.$store.state.isloading = true;
      this.$ajax({
        url: this.$url.api + "/api/account/accountCenter/register",
        method: "post",
        data: {
          companyName: company.name,
          areaCategory: company.areaCategory,
          userName: account.realname,
          mobile: account.mobile,
          appId: this.appId,
          inviteCode: this.inviteCode
        },
        headers: {
          Authorization: Session.getToken()
        }
      })
        .then(res => {
          this.$store.state.isloading = false;
          if (res.data.success) {
            this.$message.success('开通成功');
            this.redirectApp(
              Object.assign(company, {
                id: res.data.data[0]
              })
            );
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          this.$store.state.isloading = false;
          this.$message.error(err);
        });
    },
    /**
     * 跳转应用
     */
    redirectApp(company, isAdd) {
      const me = this;
      this.$ajax({
        url: this.$url.api + "/api/auth/switch/company?companyId=" + company.id,
        method: "get",
        headers: {
          Authorization: Session.getToken()
        }
      })
        .then(res => {
          let mytoken = res.data.data.token;
          let session = Session.get();
          session.account.companyId = company.id;
          if (!session.account.companies) {
            session.account.companies = [company];
          } else {
            let exists = session.account.companies.filter(
              c => c.id == company.id
            );
            if (!exists.length) {
              session.account.companies.push(company);
            }
          }
          session.span = session.timestamp - new Date().getTime();
          session.token = mytoken;
          Session.set(session);
          let url = me.$url.web[company.dcName || 'default'][company.app || 'trade-app'], sameOrigin = url.indexOf(window.location.origin) == 0,
            route = me.$route.query.portal || (company && company.b2b ? 'supplier' : 'main');
          if (!sameOrigin) {
            // 跨域直接传token
            url += '/#authorize/' + mytoken;
          } else {
            url += '/#' + route;
          }
          window.location.href = url;
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    getPartnerInfo(inviteCode) {
      const me = this;
      me.$ajax({
        url: me.$url.api + "/api/account/partner/read",
        params: {
          inviteCode
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (data && data.name) {
            me.inviteCode = inviteCode;
            me.partner = data;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>

<style scoped>
.shut {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10001;
}
</style>



// WEBPACK FOOTER //
// src/components/conenter/openupbox.vue